import React from "react";
import "./Steps.scss";

const STEPS = [
  {
    no: "01",
    title: "Tell Us Your Need",
    blurb:
      "Share your goals—software, networking, CCTV or access control. We’ll map the scope and success criteria together.",
    href: "/contact",
  },
  {
    no: "02",
    title: "Get a Consultation",
    blurb:
      "Our engineers recommend the right stack, timelines, and budget with a practical rollout plan.",
    href: "/servicespage",
  },
  {
    no: "03",
    title: "Approve & Kick Off",
    blurb:
      "We finalize milestones, security baselines, and handover plan—then begin implementation.",
    href: "/servicespage#office-setup",
  },
  {
    no: "04",
    title: "Launch & Support",
    blurb:
      "Go live with monitoring, backups, and training. We stay available with responsive support.",
    href: "/support",
  },
];

export default function Steps() {
  return (
    <section className="avena-steps" id="steps">
      <div className="container">
        <header className="steps-head text-center">
          <h2 className="steps-title">
            Few Steps for <span>Success</span>
          </h2>
          <p className="steps-sub">
            Avena delivers secure software and dependable hardware. From scoping to support,
            we keep your systems fast, visible, and easier to run.
          </p>
        </header>

        <div className="row g-4 g-lg-5 justify-content-center">
          {STEPS.map((s, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <article className="step-card text-center h-100">
                <div className="step-no">{s.no}</div>
                <h3 className="step-title">{s.title}</h3>
                <p className="step-blurb">{s.blurb}</p>
                {/* <a className="step-link" href={s.href}>
                  |&nbsp; Read more &nbsp;|
                </a> */}
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
